import * as React from 'react';
import { NavLink, } from 'react-router-dom';

import { accountCommentIcon, baseDiagnosticImageSrc, } from './shared';

import { DropdownInput, ProgressReportsSidebar, SMALL_ICON_BASE_SRC, Tooltip, pluralize, } from '../../../../../Shared/index';

const barChartIcon = <img alt="" src={`${SMALL_ICON_BASE_SRC}/bar-chart.svg`} />
const multipleCheckboxIcon = <img alt="" src={`${baseDiagnosticImageSrc}/icons-checkbox-multiple.svg`} />
const cardTextIcon = <img alt="" src={`${baseDiagnosticImageSrc}/icons-card-text.svg`} />
const tableIcon = <img alt="" src={`${baseDiagnosticImageSrc}/icons-table-account.svg`} />

export const ASSIGN_GROWTH_DIAGNOSTIC = 'Assign Growth Diagnostic'
export const ASSIGN_GROWTH_DIAGNOSTIC_SUB_PAGE = 'assign_growth_diagnostic'

export const REPORT_PAGES = [
  { label: 'Class Summary', className: 'summary-link', icon: barChartIcon, preSubPage: 'summary', postSubPage: 'growth_summary' },
  { label: 'Student Results', className: 'results-link', icon: tableIcon, preSubPage: 'results', postSubPage: 'growth_results' },
  { label: 'Student Responses', className: 'responses-link', icon: accountCommentIcon, preSubPage: 'responses', postSubPage: 'responses' },
  { label: 'Questions Analysis', className: 'questions-link', icon: cardTextIcon, preSubPage: 'questions', postSubPage: 'questions' },
  { label: 'Practice Recommendations', className: 'recommendations-link', icon: multipleCheckboxIcon, preSubPage: 'recommendations', postSubPage: 'recommendations' }
]

const VIEW_RESULTS_PAGES = REPORT_PAGES.filter(page => page.preSubPage !== 'recommendations')
const ASSIGN_PRACTICE_PAGES = REPORT_PAGES.filter(page => page.preSubPage === 'recommendations')

function pageLinks(pages, base, isPostDiagnostic, queryString) {
  return pages.map(page => ({
    ...page,
    to: base && `${base}/${isPostDiagnostic ? page.postSubPage : page.preSubPage}${queryString}`
  }))
}

function reportGroups({ activeDiagnostic, assignGrowthDiagnosticBadgeCount, hasGrowth, search, }) {
  const pre = activeDiagnostic?.pre
  const post = activeDiagnostic?.post
  const queryString = search ? search : ''
  const preBase = pre && `/diagnostics/${pre.activity_id}/classroom/${pre.classroom_id}`
  const postBase = post?.assigned_count ? `/diagnostics/${post.activity_id}/classroom/${post.classroom_id}` : null

  const groups = [
    { title: 'View Baseline Results', links: pageLinks(VIEW_RESULTS_PAGES, preBase, false, queryString) },
    { title: 'Assign Practice', links: pageLinks(ASSIGN_PRACTICE_PAGES, preBase, false, queryString) }
  ]

  if (hasGrowth) {
    groups.push(
      {
        title: ASSIGN_GROWTH_DIAGNOSTIC,
        links: [{
          label: ASSIGN_GROWTH_DIAGNOSTIC,
          className: 'assign-growth-diagnostic-link',
          icon: multipleCheckboxIcon,
          to: preBase && `${preBase}/${ASSIGN_GROWTH_DIAGNOSTIC_SUB_PAGE}${queryString}`,
          badgeCount: assignGrowthDiagnosticBadgeCount
        }]
      },
      { title: 'View Growth Results', links: pageLinks(VIEW_RESULTS_PAGES, postBase, true, '') },
      { title: 'Assign Practice', links: pageLinks(ASSIGN_PRACTICE_PAGES, postBase, true, '') }
    )
  }

  return groups
}

const LinkBadge = ({ count, }) => {
  if (!count) { return null }

  const description = `${count} ${pluralize(count, 'student is', 'students are')} ready for the growth diagnostic`

  return (
    <React.Fragment>
      <span className="sr-only">{description}</span>
      <Tooltip
        isTabbable={false}
        tooltipText={description}
        tooltipTriggerStyle={{ marginLeft: 'auto', paddingLeft: '8px' }}
        tooltipTriggerText={<span aria-hidden="true" className="count-badge">{count}</span>}
      />
    </React.Fragment>
  )
}

const ReportGroup = ({ number, title, links, }) => (
  <section className="report-group sidebar-section">
    <h2>{number}. {title}</h2>
    {links.map(link => {
      const linkContent = <React.Fragment>{link.icon}<span>{link.label}</span></React.Fragment>

      if (!link.to) { return <span className="disabled-link" key={link.label}>{linkContent}</span> }

      return (
        <NavLink activeClassName="selected" className={`focus-on-light ${link.className}`} key={link.label} to={link.to}>
          {linkContent}
          <LinkBadge count={link.badgeCount} />
        </NavLink>
      )
    })}
  </section>
)

const Sidebar = ({
  activeDiagnostic,
  assignGrowthDiagnosticBadgeCount,
  classroomOptions,
  diagnosticOptions,
  hasGrowth,
  location,
  onClassroomChange,
  onDiagnosticChange,
  selectedClassroom,
  selectedDiagnostic,
  showSidebarButton,
}) => {
  const groups = reportGroups({ activeDiagnostic, assignGrowthDiagnosticBadgeCount, hasGrowth, search: location.search, })

  const diagnosticDropdown = (
    <DropdownInput
      className="bordered small focus-on-light"
      handleChange={onDiagnosticChange}
      id="diagnostic-dropdown"
      isSearchable={false}
      label="Diagnostic"
      options={diagnosticOptions}
      value={selectedDiagnostic}
    />
  )

  return (
    <aside className="sidebar-container hide-on-mobile diagnostic-reports-sidebar">
      <ProgressReportsSidebar
        additionalDropdowns={diagnosticDropdown}
        ariaLabel="My Diagnostics Navigation"
        classroomOptions={classroomOptions}
        onClassroomChange={onClassroomChange}
        renderAsWrapper={false}
        selectedClassroom={selectedClassroom}
        showSidebarButton={showSidebarButton}
      >
        <nav className="diagnostic-report-navigation">
          {groups.map((group, i) => <ReportGroup key={`${group.title}-${i}`} links={group.links} number={i + 1} title={group.title} />)}
        </nav>
      </ProgressReportsSidebar>
    </aside>
  )
}

export default Sidebar
